import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { Routing } from '../../app.routes';
import { QueryParamMapModel } from '../../shared/services/state/auth-state.service';
import { StepperService } from '../../shared/services/stepper.service';

export const repriseProjectResolver: ResolveFn<QueryParamMapModel> = (
  route,
  state
) => {
  const router = inject(Router);
  inject(StepperService).isVisible.set(false);
  const params = route.queryParamMap;
  const uuid = params.get('uuid');
  const producerCode = params.get('producer_code');
  const referrer = params.get('referrer');
  const mode = params.get('mode');
  const entity = params.get('entity');

  if(!uuid  || !entity) {
    router.navigate([Routing.UNAUTHORIZED], {state: {data: 'error.email'}});
    return of();
  }

  return of({
    uuid,
    producerCode,
    mode,
    entity,
    referrer
  });
};
